import React from 'react'
import {LIST_LAYOUT, MOBILE_LIST_LAYOUT} from '@wix/wix-events-commons-statics'
import {useStyles} from '@wix/tpa-settings/react'
import {Calendar} from '../calendar'
import {Cards} from '../cards'
import {EmptyState} from '../empty-state'
import {ListLayout} from '../list-layout'
import {SideBySide} from '../side-by-side'
import {SingleEvent} from '../single-event'
import {CardsMobile} from '../mobile-layouts/cards-mobile'
import stylesParams from '../../../stylesParams'
import {CompactMobile} from '../mobile-layouts/compact-mobile'
import {LayoutProps} from '.'

export const Layout = ({listLayout, singleEventWidget, emptyStateVisible, narrowLayout, mobile}: LayoutProps) => {
  const mobileListLayout = useStyles().get(stylesParams.mobileListLayout)

  if (emptyStateVisible) {
    return <EmptyState />
  }

  if (singleEventWidget) {
    return <SingleEvent />
  }

  if (mobile) {
    if (listLayout === LIST_LAYOUT.CALENDAR) {
      return <Calendar />
    }
    switch (mobileListLayout) {
      case MOBILE_LIST_LAYOUT.COMPACT:
        return <CompactMobile />
      default:
        return <CardsMobile />
    }
  }

  switch (listLayout) {
    case LIST_LAYOUT.GRID:
    case LIST_LAYOUT.NEW_GRID:
      return <Cards />
    case LIST_LAYOUT.SIDE_BY_SIDE:
      return <SideBySide />
    case LIST_LAYOUT.CALENDAR:
      return <Calendar />
    default:
      if (narrowLayout) {
        return <CardsMobile />
      }
      return <ListLayout />
  }
}
